import { makeStyles, mergeClasses } from '@griffel/react';

import { tokens } from '../../util/theme/fluent9';

const sidebarPanelButtonQAClass = 'qaSidebarPanelButton';

export const useClasses = makeStyles({
  button: {
    ':hover': {
      color: tokens.colorNeutralForeground2BrandHover,
    },
    ':active': {
      color: tokens.colorNeutralForeground2BrandPressed,
    },
  },
});

export const useClassName = () => {
  const classes = useClasses();

  return mergeClasses(classes.button, sidebarPanelButtonQAClass);
};
